import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ArService } from 'src/app/services/ar.service';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'app-customer-paid',
  templateUrl: './customer-paid.component.html'
})
export class CustomerPaidComponent implements OnInit {

  filters_form: FormGroup;
  isShow: boolean = false;
  searchText;
  stations;
  arPaidTrans = [];
  activeTab;
  constructor(private spinner: NgxSpinnerService,
    private arService: ArService,
    private router: Router,
    private customerService: CustomerService
  ) {
    this.getPaidTransactions();
  }

  ngOnInit() {
    this.getPaidTransactions();
  }

  // onBackToDashboard(){
  //   this.router.navigateByUrl('home/ar-dashboard')
  // }
  // isActive(path:string){
  //   return this.router.isActive(path, false)
  //  }
  getPaidTransactions() {
    this.searchText = ''
    this.spinner.show();
    this.customerService.customerPaidTransactions().subscribe(res => {
      this.spinner.hide();
      if (res['status'] && res['result'].length > 0) {
        this.arPaidTrans = res['result'];
        //console.log(this.arPaidTrans);
      }
    });
  }

}
